<template>
	<ProcessCreatePage>
		<Header :title="$t('new_comprehensive_sign_customer').toString()">
			<p>
				{{ $t('need_person_sign') }} <strong>Kunden</strong> {{ $t('repair_shop_sign_customer', { repairShopType: repairShopLabel }) }}
			</p>
		</Header>

		<div class="main flex justify-around">
			<div class="flex flex-col">
				<BaseSign ref="BaseSign" v-model="model" @input="getPDF()" />
			</div>
			<div>
				<PDFThumbnailPreview :pdf-u-r-l="pdfURL" :uuid="uuid" show-route-params="true" :type="pdfType" />
			</div>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="true"
			:is-back-button="true"
		/>
	</ProcessCreatePage>
</template>

<script>
import AppContainerMixin from '@/mixins/AppContainerMixin';
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import BaseSign from '@/components/forms/inputs/BaseSign';
import PDFThumbnailPreview from '@/components/damagecases/forms/PDFThumbnailPreview';
import Authentication from '@/mixins/Authentication';
import { PdfApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'ProcessCreateComprehensiveSignCustomer',
	components: { PDFThumbnailPreview, BaseSign, ProcessCreatePage, Header, Footer },
	mixins: [AppContainerMixin, Authentication],
	data() {
		return {
			pdfURL: '',
			model: null,
			uuid: '',
		};
	},
	computed: {
		repairShopLabel() {
			if (this.isUserAllowedInLevel5) {
				return 'den Reparaturbetrieb';
			} else if (this.isUserAllowedInLevel6) {
				return 'das Autohaus';
			} else {
				return 'das Autohaus / den Reparaturbetrieb';
			}
		},
		pdfType() {
			return 'repair_contract';
		},
	},
	methods: {
		validate() {
			return !!this.model;
		},
		getPDF() {
			this.pdfURL = '';

			PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.pdfDamagecasesTypeTempSavePost(this.pdfType, {
					...this.$store.getters.getProcessCreateComprehensive,
					companySign: this.model,
					customerServiceSign: this.$store.getters.getProcessCreateComprehensive.customerConsultantSign,
					vehicle: {
						...this.$store.getters.getProcessCreateComprehensive.vehicle,
						registrationImage: undefined,
					},
				})
				.then(res => {
					this.uuid = res.data.uuid;
					this.pdfURL = apiDefaults.axios.defaults.baseURL + 'api/pdf/damagecases/' + res.data.uuid + '/temp/file#toolbar=0&navpanes=0&scrollbar=0';
				});
		},
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next');
			} else if (this.validate()) {
				this.$store.commit('setProcessCreateCustomerRepairOrderSign', this.model);
				this.$emit('next');
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
	mounted() {
		this.getPDF();
		this.model = this.$store.getters.getProcessCreateComprehensive.customerRepairOrderSign;
	},
};
</script>
